import Types from "../../action/types";
import Cookies from "js-cookie";

const defaultState = {
  profileObj: null,
  historyObj: [],
  subscription: null,
  authorization: Cookies.get("authorization"),
};

export default function onAction(state = defaultState, action) {
  switch (action.type) {
    case Types.PROFILEOBJ:
      return {
        ...state,
        profileObj: action.profileObj,
      };
    case Types.HISTORYOBJ:
      return {
        ...state,
        historyObj: action.historyObj,
      };
    case Types.SUBSCRIPTION:
      return {
        ...state,
        subscription: action.subscription,
      };
    case Types.AUTHORIZATION:
      return {
        ...state,
        authorization: action.authorization,
      };
    default:
      return state;
  }
}
